import React from "react";
import { ReactComponent as LogoSvg } from "assets/logo.svg";
import { twMerge } from "tailwind-merge";

export default function Logo({
  h = 20,
  w = 20,
  wrapperProps = "",
  svgProps = "",
}) {
  return (
    <div
      {...wrapperProps}
      className={twMerge(`h-70 w-70`, wrapperProps.className)}
    >
      <LogoSvg
        {...svgProps}
        className={twMerge(`h-full w-full`, svgProps.className)}
      />
    </div>
  );
}
